export default __webpack_public_path__ + "static/media/4.304cc45c.jpg";